"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _Info = _interopRequireDefault(require("@mui/icons-material/Info"));

var _reactRedux = require("react-redux");

var _features = require("../../../Shared/store/features");

var _invitationType = require("../../store/gift/invitationType");

var _InvitationTypeAvatar = _interopRequireDefault(require("./InvitationTypeAvatar"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: {
      position: 'relative',
      paddingBottom: spacing(2)
    },
    checkMark: {
      top: 61,
      left: 86,
      width: 32,
      height: 32,
      position: 'absolute',
      boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.1)',
      backgroundColor: palette.green.fruitSalad
    },
    checkMarkIcon: {
      color: palette.common.white,
      fontSize: 24
    },
    badge: {
      top: 16,
      left: 12,
      padding: spacing(1, 1, 0.75),
      fontWeight: 700,
      lineHeight: 1.3,
      height: 24,
      backgroundColor: palette.orange.main
    },
    description: {
      textAlign: 'center'
    },
    tooltipInfo: {
      marginLeft: 4,
      fontSize: '0.75rem',
      color: palette.link.main
    }
  };
});

var InvitationTypeListItem = function InvitationTypeListItem(_ref2) {
  var id = _ref2.id,
      image = _ref2.image,
      name = _ref2.name,
      remaining = _ref2.remaining,
      description = _ref2.description,
      disabled = _ref2.disabled,
      disabledTooltip = _ref2.disabledTooltip,
      selected = _ref2.selected,
      onClick = _ref2.onClick;
  var classes = useStyles();
  var handleOnClick = (0, _react.useCallback)(function () {
    if (!disabled) {
      onClick(id);
    }
  }, [onClick, id, disabled]);
  var isDirectMailEnabled = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.DIRECT_MAIL));
  var isDirectInvitationType = isDirectMailEnabled && id === _invitationType.VirtualGiftInvitationMethod.direct;
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    className: (0, _classnames.default)(classes.root, disabled ? '' : 'Text-Pointer'),
    xs: 3,
    container: true,
    direction: "column",
    alignItems: "center",
    onClick: handleOnClick
  }, /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    title: disabled ? disabledTooltip : '',
    placement: "top"
  }, isDirectInvitationType ? /*#__PURE__*/_react.default.createElement(_material.Badge, {
    color: "warning",
    classes: {
      badge: classes.badge
    },
    badgeContent: "New!",
    anchorOrigin: {
      horizontal: 'left',
      vertical: 'top'
    }
  }, /*#__PURE__*/_react.default.createElement(_InvitationTypeAvatar.default, {
    disabled: disabled,
    image: image,
    selected: selected
  })) : /*#__PURE__*/_react.default.createElement(_InvitationTypeAvatar.default, {
    disabled: disabled,
    image: image,
    selected: selected
  })), selected && /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    className: classes.checkMark
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "check",
    className: classes.checkMarkIcon
  })), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)(classes.description, {
      'Body-Regular-Center-Inactive-Bold': disabled,
      'Body-Regular-Left-Static-Bold': !disabled
    })
  }, name, isDirectMailEnabled && description && /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    title: description,
    placement: "top"
  }, /*#__PURE__*/_react.default.createElement(_Info.default, {
    className: classes.tooltipInfo
  }))), !disabled && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Small-Success"
  }, remaining));
};

var _default = /*#__PURE__*/(0, _react.memo)(InvitationTypeListItem);

exports.default = _default;